// src/features/auth/routes/AuthorRoute.tsx
import { Navigate } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useIsAuthor } from '../useIsAuthor'
import { FullScreenLoader } from './FullScreenLoader'

export const AuthorRoute = ({ children }: { children: ReactNode }) => {
  const { isAuthor, isLoading } = useIsAuthor()
  if (isLoading) return <FullScreenLoader />
  if (!isAuthor) return <Navigate to="/studio-beta" replace />
  return <>{children}</>
}
